import VueFormGenerator from "vue-form-generator";

export const DEFAULT_MEMBER_MODEL = {
  id: null,
  key: null,
  first_name: null,
  last_name: null,
  terminal_code: null,
  email: null,
  enabled: true,
  is_account_admin: false
};

const BASE_MEMBER_SCHEMA = {
  fields: [
    {
      type: "input",
      inputType: "text",
      label: "First Name",
      model: "first_name",
      placeholder: "Abraham",
      required: true
    },
    {
      type: "input",
      inputType: "text",
      label: "Last Name",
      model: "last_name",
      placeholder: "Lincoln",
      required: true
    },
    {
      type: "input",
      inputType: "text",
      label: "Job Title",
      model: "job_title",
      placeholder: "Manager",
      required: false
    },
    {
      type: "input",
      inputType: "text",
      label: "Phone",
      model: "phone",
      placeholder: "Phone Number"
    },
    {
      type: "input",
      inputType: "email",
      label: "E-mail",
      model: "email",
      placeholder: "E-mail Address"
    },
    {
      type: "checkbox",
      label: "Enabled",
      model: "enabled",
      default: true
    },
    {
      type: "checkbox",
      label: "Admin",
      model: "is_account_admin",
      default: false
    }
  ]
};

export const NEW_MEMBER_SCHEMA = {
  fields: [
    ...BASE_MEMBER_SCHEMA.fields,
    {
      type: "input",
      inputType: "text",
      label: "Terminal Code",
      model: "terminal_code",
      placeholder: "1234",
      min: 4,
      max: 4,
      required: true
      //   validator: VueFormGenerator.validators.string
    }
  ]
};

export const EDIT_MEMBER_SCHEMA = {
         fields: [
           ...BASE_MEMBER_SCHEMA.fields,
           {
             type: "input",
             inputType: "text",
             label: "Terminal Code",
             model: "terminal_code",
             placeholder: "****",
             hint: "(edit only)",
             min: 4,
             max: 4,
             required: false,
             validator: VueFormGenerator.validators.string
           },
           {
             type: "input",
             inputType: "text",
             label: "ID",
             hint: "(read only)",
             model: "id",
             readonly: true,
             disabled: true
           },
           {
             type: "input",
             inputType: "text",
             label: "Key",
             hint: "(read only)",
             model: "key",
             readonly: true,
             disabled: true
           }
         ]
       };
export const MEMBER_OPTIONS = {
  validateAfterLoad: false,
  validateAfterChanged: true,
  validateAsync: true
};

export default {
  DEFAULT_MEMBER_MODEL,
  NEW_MEMBER_SCHEMA,
  EDIT_MEMBER_SCHEMA,
  MEMBER_OPTIONS
};
